<template>
  <c-button-menu
    :loading="loading && !hasFetched['students']"
    :label="studentName"
    outline
    :menu-options="{
      listItems: studentMenuItems,
    }"
    :menu-offset="[0, 10]"
    @before-show="openMenu"
  >
    <div class="tw-sticky tw-top-0 tw-z-20 tw-bg-white tw-p-4">
      <c-input
        v-model="searchVal"
        placeholder="Zoek leerling"
        debounce="300"
        autofocus
        dense
      />
    </div>
  </c-button-menu>
</template>

<script setup>
import useHelpers, { mappedTerms } from "composables/useHelpers";
import { storeToRefs } from "pinia";
import { useQuasar } from "quasar";
import { useAuthorizationStore } from "store/modules/authorizationStore";
import { useGlobalSchoolDataStore } from "store/modules/globalSchoolDataStore";
import { computed, ref } from "vue";

const { schoolId } = useHelpers();

// Quasar
const $q = useQuasar();

// Authorization Store
const authorizationStore = useAuthorizationStore();
const { impersonateUser } = authorizationStore;

// Webmaster store
const globalSchoolDataStore = useGlobalSchoolDataStore();
const { fetchStudents } = globalSchoolDataStore;
const { students, hasFetched } = storeToRefs(globalSchoolDataStore);

// Refs
const searchVal = ref("");
const loading = ref(false);
const studentName = computed(() =>
  localStorage.getItem("impersonated_user_type") === "student"
    ? localStorage.getItem("first_name")
    : mappedTerms.student.capitalize(),
);

const studentMenuItems = computed(() => {
  return students.value
    .filter(({ id, email, first_name, middle_name, last_name }) => {
      const searchString = searchVal.value.toLowerCase();

      // This will prevent errors when any of the fields are null or undefined
      first_name ||= "";
      middle_name ||= "";
      last_name ||= "";
      email ||= "";

      return (
        first_name.toLowerCase().includes(searchString) ||
        middle_name.toLowerCase().includes(searchString) ||
        last_name.toLowerCase().includes(searchString) ||
        email.toLowerCase().includes(searchString) ||
        id.toString().includes(searchString)
      );
    })
    .map((student) => {
      const {
        user_id = null,
        first_name = null,
        middle_name = null,
        last_name = null,
      } = student;

      if (!user_id) {
        $q.notify({
          type: "negative",
          message: "User ID is missing",
        });
      }

      const fullName = [first_name, middle_name, last_name]
        .filter(Boolean)
        .join(" ");

      return {
        label: fullName,
        onClick: () =>
          impersonateUser({
            userId: user_id,
            impersonatedUserType: "student",
          }),
      };
    });
});

const openMenu = async () => {
  loading.value = true;

  await fetchStudents({ schoolId });

  loading.value = false;
};
</script>
